export const MODEM_DISCLAIMER = 'You’ll need to make sure your modem works with the nbn service, and you’ll need to know the basics on troubleshooting the device. For anything else, you’d need to check with the manufacturer directly.'
export const SAME_AS_INSTALL_ADDRESS = 'same_as_install_address'
export const REQUIRES_MODEM = 'requires_modem'
export const ATTENTION_TO_KEY = 'name'
export const DEFAULT_RESPONSE_ERROR = 'We encountered an issue while trying to save your details, please try again'
export const GA_CATEGORY = 'Modem'



// WEBPACK FOOTER //
// ./containers/stages/ModemStage/constants.js